/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setPayersForCustomer} from '../api'

export const useMutationSetPayersForCustomer = createReactQueryMutationHook('setPayersForCustomer', setPayersForCustomer)
